$(document).ready(function () {
    
    $(".custom-header__tool--menu").click(function(e){
        e.preventDefault();
        let announcement = $(".custom-announcement__wrapper");
        if(announcement){
            $(".custom-mobile-header").attr("style", `height: calc(100vh - ${announcement.outerHeight()}px); top: ${announcement.outerHeight()}px;`);
        }
        $(".custom-mobile-header").slideDown(300);
    });

    $(".custom-header__tool--cross").click(function(e){
        e.preventDefault();
        $(".custom-mobile-header").slideUp(300);
    });

    $(".custom-mobile-nav--toggle").click(function(e){
        $(".custom-mobile-nav--toggle").removeClass("active");
        $(this).addClass("active");
        e.preventDefault();
        $(this).next(".custom-mobile__nav").slideToggle();
    });

    $(".custom-header__megamenu--toggle-hover").hover(function(e){
        if($(this).hasClass("custom-header__megamenu--toggle")){
            // e.preventDefault();
            closeDrawers(false, true, true, true, true);
            if ($(".custom-header__search-wrapper-main").hasClass("active")) {
                $(".custom-header__search-wrapper-main").removeClass("active");
                $(".custom-header__tool-search").removeAttr("style").siblings().removeAttr("style");
            }
            let announcement = $(".custom-announcement__wrapper");
            let headerNavItems = $(".custom-header__nav-list");
            if(announcement){
                $(".custom-header__megamenu-wrapper-main").attr("style", `height: calc(100vh - ${announcement.outerHeight()}px);`);
            }
            if(headerNavItems && headerNavItems.length >= 2){
                let headerNavWidth = 46;
                $(".custom-header__nav-list").each(function(){
                    headerNavWidth += $(this).outerWidth();
                });
                $(".custom-header__megamenu-grandchild-wrapper").attr("style", `width: ${headerNavWidth}px;`);
            }
            $(".custom-header__megamenu-grandchild-wrapper, .custom-header__megamenu-grandchild, .custom-header__megamenu-child, .custom-header__megamenu-wrapper-main").removeClass("active");
            $(".custom-header__wrapper").removeClass("custom-header--megamenu-child custom-header--megamenu");
            let $this = $(this);
            setTimeout(function(){
                $(".custom-header__wrapper").addClass("custom-header--megamenu");
                $this.next(".custom-header__megamenu-wrapper-main").addClass("active").find(".custom-header__megamenu-child").addClass("active");
                if($this.hasClass("custom-header__megamenu--toggle-collection-first")){
                    let title = $this.attr("data-title");
                    $(".custom-header__wrapper").addClass("custom-header--megamenu-child");
                    $this.next().find(".custom-header__megamenu-collection").each(function(){
                        if($(this).attr("data-title") == title){
                            $(this).show();
                        }
                    });
                }
            }, 50);
        }
        else{
            closeDrawers(false, true, true, true, true);
            if ($(".custom-header__search-wrapper-main").hasClass("active")) {
                $(".custom-header__search-wrapper-main").removeClass("active");
                $(".custom-header__tool-search").removeAttr("style").siblings().removeAttr("style");
            }
            $(".custom-header__megamenu-grandchild-wrapper, .custom-header__megamenu-grandchild, .custom-header__megamenu-child, .custom-header__megamenu-wrapper-main").removeClass("active");
            $(".custom-header__wrapper").removeClass("custom-header--megamenu-child custom-header--megamenu");
        }
    });

    $(".custom-header__megamenu--toggle-child").click(function(e){
        e.preventDefault();
        let title = $(this).attr("data-title");
        $(".custom-header__megamenu-grandchild-wrapper, .custom-header__megamenu-grandchild").removeClass("active");
        $(".custom-header__wrapper").addClass("custom-header--megamenu-child");
        $(".custom-header__megamenu-grandchild").hide();
        $(this).parents(".custom-header__megamenu-wrapper").find(".custom-header__megamenu-grandchild").each(function(){
            if($(this).attr("data-title") == title){
                $(this).show();
                $(this).addClass("active");
                $(this).parent().addClass("active");
            }
        });
    });

    $(".custom-header__megamenu--toggle-collection").click(function(e){
        e.preventDefault();
        if($(this).hasClass("custom-header__megamenu--toggle-collection-second")){
            $(".custom-header__megamenu-grandchild-wrapper").removeClass("active");
        }
        let title = $(this).attr("data-title");
        $(".custom-header__megamenu-collection").hide();
        $(this).parents(".custom-header__megamenu-wrapper").find(".custom-header__megamenu-collection").each(function(){
            if($(this).attr("data-title") == title){
                $(this).show();
            }
        });
    });

    $(".custom-header__megamenu--toggle-collection-first + .custom-header__megamenu-wrapper-main .custom-header__megamenu-collection-wrapper").click(function(e){
        e.stopPropagation();
    })

    $(".custom-header__megamenu-wrapper-main, .custom-header__megamenu-close").click(function(){
        $(".custom-header__megamenu-grandchild-wrapper, .custom-header__megamenu-child, .custom-header__megamenu-wrapper-main, .custom-header__megamenu-grandchild").removeClass("active");
        $(".custom-header__wrapper").removeClass("custom-header--megamenu-child custom-header--megamenu");
        $(".custom-header__megamenu-link, .custom-header__nav-link").removeClass("custom-header__link--active-state");
        $(".custom-header__nav-link").removeClass("custom-header__link--inactive-state");
    });

    $(".custom-header__megamenu-child, .custom-header__megamenu-grandchild, .custom-header__search-box, .custom-header__account-box").click(function(e){
        e.stopPropagation();
    });

    $(".custom-header__tool-search").click(function(e) {
        closeDrawers(true, false, true, true, true);
        setTimeout(() => {
            if ($(".custom-header__wrapper").hasClass("custom-header--megamenu")) {
                $(".custom-header__wrapper").removeClass("custom-header--megamenu");
            }
            if ($(".custom-header__megamenu-wrapper-main").hasClass("active")) {
                $(".custom-header__megamenu-wrapper-main").removeClass("active");
            }
            if ($(".custom-header__megamenu-child").hasClass("active")) {
                $(".custom-header__megamenu-child").removeClass("active");
            }
            let announcement = $(".custom-announcement__wrapper");
            if(announcement){
                $(".custom-header__search-wrapper-main").attr("style", `height: calc(100vh - ${announcement.outerHeight()}px);`);
            }
            $(".custom-header__tool").addClass("custom-header__search-drawer-active");
            $(".custom-header__search-wrapper-main").addClass("active");
        }, 50);
    })

    $(".custom-header__search-wrapper-main, .custom-header__search-close").click(function(e) {
        $(".custom-header__tool").removeClass("custom-header__search-drawer-active");
        $(".custom-header__search-wrapper-main").removeClass("active");
    })

    $(".custom-header__account-close, .custom-header__account-wrapper").click(function(e) {
        $(".custom-header__tool").removeClass("custom-header__account-drawer-active");
        $(".custom-header__account-wrapper-main").removeClass("active");
        if (window.history) {
            window.history.pushState('', document.title, window.location.href.replace(window.location.hash, ''));
        }
    })

    function closeDrawers(menu=false, search=false, cart=false, account=false, filter=false){
        if(menu){
            $(".custom-header__megamenu-wrapper-main").trigger("click");
        }
        if(search){
            $(".custom-header__search-close").trigger("click");
        }
        if(cart){
            $(".drawer__header .drawer__close").trigger("click");
        }
        if(account){
            $(".custom-header__account-close").trigger("click");
        }
        if(filter){
            $(".mobile-facets__close").trigger("click");
        }
    }

    $(".custom-header__tool--cart").click(function(){
        closeDrawers(true, true, false, true, true);
    });

    let searchRecommendationsWrapper = document.querySelector('.custom-header__search-recommendation');
    if(searchRecommendationsWrapper){
        fetch(window.Shopify.routes.root + "collections/all?view=bestselling.json&sort_by=best-selling")
        .then(response => response.text())
        .then((text) => {
            if(text != ''){
                fetch(window.Shopify.routes.root + `recommendations/products?product_id=${text}&limit=10&section_id=search-recommended-products&intent=related`)
                .then(response => response.text())
                .then((text) => {
                    const searchRecommendationsSection = document.querySelector('.custom-header__search-recommendation ul');
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('#shopify-section-search-recommended-products');
                    if(recommendations && recommendations.innerHTML.trim().length) {
                        searchRecommendationsSection.innerHTML = recommendations.innerHTML;
                    }
                }).catch((err) => {
                    console.log("Search drawer recommendation error", err);
                    searchRecommendationsWrapper.style.display = "none";
                });
            }
        }).catch((err) => {
            console.log("Search drawer bestselling error", err);
            searchRecommendationsWrapper.style.display = "none";
        });
    }

    function delay(callback, ms) {
        var timer = 0;
        return function() {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
            callback.apply(context, args);
            }, ms || 0);
        };
    }

    document.querySelector(".custom-header--search-input").addEventListener("input", delay(function(e){
        const query = e.target.value;
        const searchResultSectionWrapper = document.querySelector('.custom-header__search-result');
        const searchRecommendationsSectionWrapper = document.querySelector('.custom-header__search-recommendation');
        if(query.length > 2){
            //fetch(window.Shopify.routes.root + `search/suggest?q=${query}&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&section_id=predictive-search-products`)
            fetch(window.Shopify.routes.root + `search/suggest?q=${query}&resources[type]=product&resources[options]&resources[options][fields]=title,product_type,variants.title&section_id=predictive-search-products`)
            .then(response => response.text())
            .then((text) => {
                const searchResultSection = document.querySelector('.custom-header__search-result ul');
                const html = document.createElement('div');
                html.innerHTML = text;
                const searchResults = html.querySelector('#shopify-section-predictive-search-products');
                if(searchResults && searchResults.innerHTML.trim().length) {
                    searchResultSection.innerHTML = searchResults.innerHTML;
                }
                searchRecommendationsSectionWrapper.style.display = "none";
                searchResultSectionWrapper.style.display = "block";
            }).catch((err) => {
                console.log("Search drawer result error", err);
                searchResultSectionWrapper.style.display = "none";
            });
        }
        else{
            searchResultSectionWrapper.style.display = "none";
            searchRecommendationsSectionWrapper.style.display = "block";
        }
    }, 500));

    $(".custom-header__tool-account span").click(function(e) {
      if(!$(this).hasClass("custom-customer-logged-in")){
        e.preventDefault();
        closeDrawers(true, true, true, false, true);
        setTimeout(() => {
            if ($(".custom-header__wrapper").hasClass("custom-header--megamenu")) {
                $(".custom-header__wrapper").removeClass("custom-header--megamenu");
            }
            if ($(".custom-header__megamenu-wrapper-main").hasClass("active")) {
                $(".custom-header__megamenu-wrapper-main").removeClass("active");
            }
            if ($(".custom-header__megamenu-child").hasClass("active")) {
                $(".custom-header__megamenu-child").removeClass("active");
            }
            let announcement = $(".custom-announcement__wrapper");
            if(announcement){
                $(".custom-header__account-wrapper-main").attr("style", `height: calc(100vh - ${announcement.outerHeight()}px);`);
            }
            $(".custom-header__tool").addClass("custom-header__account-drawer-active");
            $(".custom-header__account-wrapper-main").addClass("active");
        }, 50);
      }
    })

    $(window).on("scroll", delay(function(){
        let header = $(".custom-header");
        if(header.hasClass("custom-header--pdp") && $(this).scrollTop() > 25){
            $(".custom-header--pdp").addClass("custom-header--pdp-bg");
        }
        else{
            $(".custom-header--pdp").removeClass("custom-header--pdp-bg");
        }
    }, 50));

    let template = $("body").attr("data-template");
    if(template == 'collection'){
        let facets = $("#custom-facets__wrapper").detach();
        $(".custom-header__tool-filter").append(facets);
    }
    $(".custom-facets__trigger").click(function(){
        let announcement = $(".custom-announcement__wrapper");
        if(announcement){
            $("#FacetFiltersFormMobile").attr("style", `height: calc(100vh - ${announcement.outerHeight()}px); top: ${announcement.outerHeight()}px;`);
        }
        if($(".custom-header__tool-list")){
            let totalToolWidth = 0;
            $(".custom-header__tool-list").each(function(){
                if(!$(this).hasClass("custom-header__tool--menu")){
                    totalToolWidth += $(this).outerWidth();
                }
            })
            $(".fiter_sorting_wrapper .mobile-facets__details").attr("style", `width: calc(100% / 2.7)`);
            $(".fiter_sorting_wrapper .mobile-facets__list").attr("style", `width: calc((100% / 3) - 70px)`);
        }
        if($("#custom-facets__wrapper .mobile-facets__open-wrapper")){
            $("#custom-facets__wrapper .mobile-facets__open-wrapper").trigger("click");
            $(this).toggleClass("custom-facets__active");
            $("body").toggleClass("overflow-hidden");
            $('html, body').scrollTop(0);
        }
    })
    $(".mobile-facets__close").click(function(){
        if($("#custom-facets__wrapper .mobile-facets__open-wrapper")){
            if($("#custom-facets__wrapper .mobile-facets__open-wrapper").parent().hasClass("menu-opening")){
                $("#custom-facets__wrapper .mobile-facets__open-wrapper").trigger("click");
            }
            $(".custom-facets__trigger").removeClass("custom-facets__active");
            $("body").removeClass("overflow-hidden");
            $('html, body').scrollTop(0);
        }
    });
    $("#FacetFiltersFormMobile").click(function(){
        if($("#custom-facets__wrapper .mobile-facets__open-wrapper")){
            $("#custom-facets__wrapper .mobile-facets__open-wrapper").trigger("click");
            $(".custom-facets__trigger").removeClass("custom-facets__active");
            $("body").removeClass("overflow-hidden");
            $('html, body').scrollTop(0);
        }
    });
    $(".mobile-facets__inner").click(function(e){
        e.stopPropagation();
    });
    
    $(".custom-header__nav-link").click(function(){
        $(".custom-header__megamenu-link").removeClass("custom-header__link--active-state");
        $(this).parents("ul").find(".custom-header__nav-link").removeClass("custom-header__link--active-state").addClass("custom-header__link--inactive-state");
        $(this).addClass("custom-header__link--active-state").removeClass("custom-header__link--inactive-state");
    });

    $(".custom-header__megamenu-link").click(function(){
        $(this).parents(".custom-header__megamenu-nav").find(".custom-header__megamenu-link").removeClass("custom-header__link--active-state");
        $(this).addClass("custom-header__link--active-state");
    });

    if($(window).width() > 750){
        let temp = $("body").attr("data-template");
        if(temp == 'product'){
            let wrapper = $(".custom-pdp--form-wrapper");
            let lastImage = $(".product__media-item:last-child").offset().top + $(".product__media-item:last-child").outerHeight();
            let mediaGalleryHeight = $("[data-custom-media-gallery]").outerHeight();
            let infoWrapperHeight = $(".custom-product-info--wrapper").outerHeight();
            if(mediaGalleryHeight > infoWrapperHeight){
                let bottom = $(this).scrollTop() + $(".custom-product-info--wrapper").outerHeight();
                let buttonPosition = lastImage + $(".custom-pdp--form-wrapper-container").position().top - $(".custom-header").outerHeight();
                if(bottom > buttonPosition){
                    let det = wrapper.detach();
                    $(".custom-product__info-wrapper").prepend(det);
                    $(".custom-pdp--form-wrapper").attr("style", `top: ${$(".custom-header").outerHeight()}px !important`);
                }
                else{
                    let det = wrapper.detach();
                    $(".custom-pdp--form-wrapper-container").append(det);
                    $(".custom-pdp--form-wrapper").removeAttr("style");
                }
            }
            else{
                let bottom = $(this).scrollTop() + mediaGalleryHeight;
                let buttonPosition = $(".custom-product-info--wrapper").offset().top + $(".custom-product-info--wrapper").outerHeight() + $(".custom-pdp--form-wrapper-container").position().top - $(".custom-header").outerHeight();
                if(bottom > buttonPosition){
                    let det = wrapper.detach();
                    $(".custom-pdp--form-wrapper-container").addClass("custom-form-wrapper-height-auto");
                    $(".custom-product__info-wrapper").prepend(det);
                    $(".custom-pdp--form-wrapper").attr("style", `top: ${$(".custom-header").outerHeight()}px !important`);
                }
                else{
                    let det = wrapper.detach();
                    $(".custom-pdp--form-wrapper-container").removeClass("custom-form-wrapper-height-auto");
                    $(".custom-pdp--form-wrapper-container").append(det);
                    $(".custom-pdp--form-wrapper").removeAttr("style");
                }
            }
        }
    }

    $(window).on("scroll", delay(function(e){
        if($(window).width() > 750){
            let temp = $("body").attr("data-template");
            if(temp == 'product'){
                let wrapper = $(".custom-pdp--form-wrapper");
                let lastImage = $(".product__media-item:last-child").offset().top + $(".product__media-item:last-child").outerHeight();
                let mediaGalleryHeight = $("[data-custom-media-gallery]").outerHeight();
                let infoWrapperHeight = $(".custom-product-info--wrapper").outerHeight();
                if(mediaGalleryHeight > infoWrapperHeight){
                    let bottom = $(this).scrollTop() + $(".custom-product-info--wrapper").outerHeight();
                    let buttonPosition = lastImage + $(".custom-pdp--form-wrapper-container").position().top - $(".custom-header").outerHeight();
                    if(bottom > buttonPosition){
                        let det = wrapper.detach();
                        $(".custom-product__info-wrapper").prepend(det);
                        $(".custom-pdp--form-wrapper").attr("style", `top: ${$(".custom-header").outerHeight()}px !important`);
                    }
                    else{
                        let det = wrapper.detach();
                        $(".custom-pdp--form-wrapper-container").append(det);
                        $(".custom-pdp--form-wrapper").removeAttr("style");
                    }
                }
                else{
                    let bottom = $(this).scrollTop() + mediaGalleryHeight;
                    let buttonPosition = $(".custom-product-info--wrapper").offset().top + $(".custom-product-info--wrapper").outerHeight() + $(".custom-pdp--form-wrapper-container").position().top - $(".custom-header").outerHeight();
                    if(bottom > buttonPosition){
                        let det = wrapper.detach();
                        $(".custom-pdp--form-wrapper-container").addClass("custom-form-wrapper-height-auto");
                        $(".custom-product__info-wrapper").prepend(det);
                        $(".custom-pdp--form-wrapper").attr("style", `top: ${$(".custom-header").outerHeight()}px !important`);
                    }
                    else{
                        let det = wrapper.detach();
                        $(".custom-pdp--form-wrapper-container").removeClass("custom-form-wrapper-height-auto");
                        $(".custom-pdp--form-wrapper-container").append(det);
                        $(".custom-pdp--form-wrapper").removeAttr("style");
                    }
                }
            }
        }
    }, 100));
});